import { Context, Layer, Redacted } from "effect";

export type BaseConfigShape = {
  readonly database: {
    readonly url: Redacted.Redacted;
  };
  readonly environment: "dev" | "prod" | "test";
  readonly sentry: {
    readonly dsn: string | undefined;
  };
};

export class BaseConfig extends Context.Service<
  BaseConfig,
  BaseConfigShape
>()("@vivus/BaseConfig") {}

export type BaseConfigEnv = {
  DATABASE_URL: string;
  ENVIRONMENT: string;
  SENTRY_DSN?: string | undefined;
};

export const makeBaseConfigLayer = (env: BaseConfigEnv) =>
  Layer.succeed(BaseConfig, {
    database: { url: Redacted.make(env.DATABASE_URL) },
    environment: env.ENVIRONMENT as "dev" | "prod" | "test",
    sentry: { dsn: env.SENTRY_DSN },
  });
